import React from "react";
import Modal from "react-modal";

const ImageModal = ({ isOpen, onRequestClose, imageUrl }) => {

    const modalStyle = {
        content: {
          maxWidth: "80%", 
          margin:"auto",
        },
      };
    
      const containerStyle = {
      
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "transparent",
      };
    
      const imageStyle = {
        padding:"20px",
        maxWidth: "100%", // Set the maximum width for the image
        maxHeight: "100%", // Set the maximum height for the image
      };
    
      const closeButtonStyle = {
        position: "absolute",
        top: "10px", // Adjust the top position as needed
        right: "10px", // Adjust the right position as needed
        cursor: "pointer",
        

       
      };

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="Enlarged Image"
        ariaHideApp={false} // Disable the accessibility feature temporarily
        style={modalStyle}
      >
        <div className="image-container" style={containerStyle}>
        <img src={imageUrl} alt="Enlarged Image"  style={imageStyle}/>
        <button onClick={onRequestClose} style={closeButtonStyle} className="btn btn-danger ">X</button>
        </div>
      </Modal>
    );
  };
  

export default ImageModal;